import { AdminDashboardView } from './js/admin-dashboard';
import { DiagnosticsWatcher } from '@ui/DiagnosticsWatcher';
import { FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { MaintenanceView } from './js/gateway/maintenance';
import React from 'react';
import { SalesforceIntegration } from './js/gateway/integrations/Salesforce';
import { SharedDataDictionaryView } from '@dictionary/SharedDataDictionaryView';

import {
	AuthorizedView,
	AuthTokenRedirect,
	ConfirmLinkRouter,
	ExtensionAuthClose,
	UnauthorizedView
} from './js/gateway';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Else, If, Then } from 'react-if';
import { useAuthToken, useMaintenanceMode } from '@hooks';

export const AppRoot: React.FC = () => {
	const { isAdmin, isLoggedIn } = useAuthToken();
	const inMaintenanceMode = useMaintenanceMode();

	return (
		<>
			<ExtensionAuthClose />
			<BrowserRouter>
				<DiagnosticsWatcher />
				<If condition={ inMaintenanceMode }>
					<Then>
						<MaintenanceView />
					</Then>
					<Else>
						<Routes>
							<Route
								element={ <ConfirmLinkRouter /> }
								path={ FULL_ROUTES.CONFIRM_LINK } />
							<Route
								element={ <AuthTokenRedirect /> }
								path={ FULL_ROUTES.TOKEN } />
							<Route
								element={ <SalesforceIntegration /> }
								path={ FULL_ROUTES.INTEGRATIONS_SALESFORCE } />
							<Route
								element={ <SharedDataDictionaryView /> }
								path={ FULL_ROUTES.SHARED_VIEW } />
							{ isAdmin && <Route
								element={ <AdminDashboardView /> }
								path={ FULL_ROUTES.ADMIN } /> }
							<Route
								element={ isLoggedIn ? <AuthorizedView /> : <UnauthorizedView /> }
								path='*' />
						</Routes>
					</Else>
				</If>
			</BrowserRouter>
		</>
	);
};
